<template>
  <main id="content" aria-labelledby="main-title" v-if="page">
    
    <ClientOnly>
      <div class="hero--info bg-faun" v-if="currentView === 'client' && clientData">
        <Container>
          <FadeIn class="pt-16 sm:pt-24 pb-6 sm:pb-8 text-center max-w-2xl mx-auto">
            <div class="mb-6">
              <NuxtLink
              v-if="clientData.url"
              target="_blank"
              :to="clientData.url"
              >
              <img
              :src="clientData.logo"
              :alt="`${clientData.title} x Elker: Safe Space for Reporting`"
              class="h-auto w-[140px] mx-auto"
              :style="clientData.logoStyle"
              loading="lazy"
              />
              </NuxtLink>
              <img
              v-else
              :src="clientData.logo"
              :alt="`${clientData.title} x Elker: Safe Space for Reporting`"
              class="h-auto w-[140px] mx-auto"
              :style="clientData.logoStyle"
              loading="lazy"
              />
            </div>
            <div class="mb-2 md:mb-4">
            </div>
            <h1 id="main-title" class="text-black text-2xl sm:text-2xl md:text-3xl font-bold tracking-tight">
              {{ clientData.heroTitle || `${clientData.title} wants people to feel safe to speak up about anything` }}
            </h1>
          </FadeIn>
        </Container>
      </div>
    </ClientOnly>

    <ElementHero v-if="currentView !== 'client' && page?.hero" :content="page?.hero" />

    <template v-if="currentView === 'client' && clientData">
      <Section margins="reset-top">
        <Container>
          <FadeIn>
            <div class="bg-[#f9f8f6]">
              <div class="mx-auto max-w-[800px]">
                <div>
                  <p v-if="clientData.partnershipText" class="text-md font-semibold leading-6 text-gray-900">
                    {{ clientData.partnershipText }}
                  </p>
                  <div v-if="clientData.showTogetherWithElker" class="flex flex-col items-center justify-center mt-2 mb-6 gap-3">
                    <span class="text-sm text-gray-600">Together with</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 615 188" fill="none" class="h-8 w-auto">
                      <path d="M238.824 164.383c-10.608 0-19.739-2.149-27.392-6.445-7.609-4.342-13.473-10.474-17.59-18.396-4.118-7.967-6.177-17.389-6.177-28.265 0-10.608 2.059-19.917 6.177-27.929s9.914-14.255 17.388-18.731c7.52-4.476 16.337-6.714 26.452-6.714 6.804 0 13.137 1.097 19 3.29 5.908 2.148 11.056 5.393 15.442 9.735 4.431 4.341 7.877 9.802 10.339 16.382 2.462 6.535 3.693 14.188 3.693 22.961v7.855h-87.078v-17.724h60.155c0-4.118-.895-7.766-2.685-10.943a19.23 19.23 0 0 0-7.452-7.452c-3.133-1.835-6.781-2.753-10.944-2.753-4.341 0-8.19 1.007-11.547 3.021a21.18 21.18 0 0 0-7.788 7.989c-1.88 3.312-2.842 7.005-2.887 11.078v16.851c0 5.103.94 9.511 2.82 13.226 1.924 3.715 4.632 6.58 8.123 8.594s7.632 3.021 12.421 3.021c3.177 0 6.087-.448 8.728-1.343s4.901-2.238 6.78-4.028 3.312-3.983 4.297-6.579l26.452 1.745c-1.342 6.356-4.095 11.906-8.258 16.65-4.117 4.7-9.444 8.37-15.978 11.011-6.49 2.596-13.987 3.894-22.491 3.894zm88.924-139.512v137.498h-28.6V28.894l28.6-4.023zm43.154 107.823l.067-34.307h4.163l33.032-39.141h32.83l-44.378 51.83h-6.781l-18.933 21.618zm-25.915 29.675V28.894l28.601-4.023v137.498h-28.601zm64.452 0l-30.346-44.915 19.067-20.209 44.781 65.124h-33.502zm82.664 2.014c-10.607 0-19.738-2.149-27.392-6.445-7.609-4.342-13.472-10.474-17.59-18.396-4.117-7.967-6.176-17.389-6.176-28.265 0-10.608 2.059-19.917 6.176-27.929s9.914-14.255 17.389-18.731c7.519-4.476 16.337-6.714 26.452-6.714 6.803 0 13.137 1.097 19 3.29 5.908 2.148 11.055 5.393 15.441 9.735 4.432 4.341 7.878 9.802 10.34 16.382 2.461 6.535 3.692 14.188 3.692 22.961v7.855h-87.077v-17.724h60.155c0-4.118-.895-7.766-2.685-10.943a19.24 19.24 0 0 0-7.453-7.452c-3.133-1.835-6.781-2.753-10.943-2.753-4.342 0-8.191 1.007-11.548 3.021a21.18 21.18 0 0 0-7.788 7.989c-1.879 3.312-2.842 7.005-2.886 11.078v16.851c0 5.103.939 9.511 2.819 13.226 1.925 3.715 4.633 6.58 8.124 8.594s7.631 3.021 12.42 3.021c3.178 0 6.087-.448 8.728-1.343s4.901-2.238 6.781-4.028 3.312-3.983 4.297-6.579l26.452 1.745c-1.343 6.356-4.095 11.906-8.258 16.65-4.118 4.7-9.444 8.37-15.979 11.011-6.49 2.596-13.987 3.894-22.491 3.894zm60.325-2.014V59.246h25.716l2.011 17.993h1.074c1.88-6.401 5.036-11.234 9.467-14.502 4.431-3.312 9.533-4.968 15.307-4.968a43.29 43.29 0 0 1 4.633.269c1.656.179 3.11.425 4.364.739v25.378c-1.343-.403-3.201-.761-5.573-1.074s-4.543-.47-6.512-.47c-4.207 0-7.967.918-11.279 2.753-3.268 1.79-5.864 4.297-7.788 7.519-1.88 3.223-2.82 6.938-2.82 11.144v58.343h-28.6z" fill="#090d16"></path><path d="M0 142.5c0 15.285 12.891 22.183 28.646 25.564l69.708 18.076c.096.025.189-.048.189-.147v-52.825L0 124.446V142.5z" fill="#c0c7fa"></path><path d="M0 67.911c0-18.125 12.891-29.622 28.646-33.274L163.812 1.005c.096-.024.188.049.188.148v61.146c0 .078-.059.144-.137.151L0 78.329V67.911z" fill="#5a6ded"></path><path d="M0 119.414l98.543 7.71 32.495 2.288c.088.006.162-.064.162-.152V71.939L0 83.3v36.114z" fill="#8293f8"></path>
                    </svg>
                  </div>
                  <p class="text-md font-semibold leading-6 text-gray-900 mt-4">
                    Your options for reporting are:
                  </p>
                </div>
                <ul role="list" class="grid grid-cols-1 gap-6 md:grid-cols-2 mt-8">
                  <li
                  v-for="item in clientData.channels"
                  :key="item.title"
                  class="relative flex flex-col flex-grow py-4 bg-white rounded-lg p-4 border-2 border-[#e8e5de]"
                  >
                    <!-- <div class="hidden lg:flex h-10 w-10 flex-none items-center justify-center rounded-lg ring-1 ring-[#E4E2DF]">
                      <Icon name="iconoir:security-pass" color="#6073EE" class="h-8 w-8 text-[#5a6ded]" />
                    </div> -->
                    <div class="flex-auto">
                      <h3 class="text-lg font-semibold leading-6 mb-2">
                        {{ item.title }}
                      </h3>
                      <div class="text-base text-gray-500" v-html="item.description"></div>
                    </div>

                    <!-- Badge (optional) -->
                    <div v-if="item.badge || clientData.badge" class="mt-4">
                      <img
                      :src="item.badge || clientData.badge"
                      :alt="item.badgeAlt || clientData.badgeAlt || 'Badge'"
                      class="h-20 w-20 object-contain"
                      loading="lazy"
                      />
                    </div>
                  </li>
                </ul>

                <!-- Security Features Strip -->
                <div class="mt-8 pt-6 border-t border-gray-200">
                  <div class="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm text-gray-600">
                    <div class="flex items-center gap-2">
                      <Icon name="material-symbols:shield-lock-outline" class="h-5 w-5 text-[#3645d0]" />
                      <span>All data encrypted</span>
                    </div>
                    <div class="flex items-center gap-2">
                      <Icon name="material-symbols:visibility-off" class="h-5 w-5 text-[#3645d0]" />
                      <span>Anonymous reporting</span>
                    </div>
                    <div class="flex items-center gap-2">
                      <Icon name="material-symbols:verified-outline" class="h-5 w-5 text-[#3645d0]" />
                      <span>ISO27001 certified / SOC 2 attested</span>
                    </div>
                  </div>
                </div>

                <div
                v-if="clientData.url && clientData.title !== 'Elker'"
                class="text-center text-sm leading-6 text-gray-500 mt-8"
                >
                  Visit the <a :href="clientData.url" class="underline">{{ clientData.title }} website</a>
                </div>
              </div>
            </div>
          </FadeIn>
        </Container>
      </Section>
    </template>
    
    <template v-else>
      <template v-if="page?.dynamic">
        <template v-for="(section, index) in page?.dynamic">
          <component 
          :is="getSectionComponent(section.collection)" 
          :sectionIndex="index" 
          :sectionTotal="page.dynamic.length"
          :content="section.item" 
          />
        </template>
      </template>

      <ElementBookDemoCta title="Partner with Elker for lasting change" subtitle="Join leading organisations that have chosen Elker to drive meaningful change" />

    </template>

  </main>
</template>

<script setup>
import { trustClients } from '~/data/trust-clients'

const route = useRoute()

const clientSlug = computed(() => route.query?.client || null)
const clientData = computed(() => (
  clientSlug.value
    ? trustClients.find(client => client.slug === clientSlug.value) || null
    : null
))
const currentView = computed(() => (clientData.value ? 'client' : 'base'))
const contentSections = useContentSections()
const { getItems } = useCms()
const fields = useFields()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const getSectionComponent = key => {
  return contentSections[key]
}

const { data } = await useAsyncData(
  currentLocale.value+'-page-trust',
  () => getItems({
    collection: 'page',
    params: {
      filter: {
        slug: {
          "_eq": "trust"
        }
      },
      fields
    },
  })
)

const page = data?.value[0]

const seo = computed(() => {
  return page?.seo ? useSeo(page.seo, route.fullPath) : {}
})

useHead(seo)

</script>